import * as React from "react";
import { useSelector } from "react-redux";
import { setTimeout, clearTimeout } from "timers";
import { ReadyState } from "react-relay";

// components
import { CalloutButton, CalloutButtonProps } from "@clockwise/web-commons/src/ui/callout";

// util
import { calculateBackoffTimeout } from "@clockwise/client-commons/src/util/network";

// state
import { IReduxState } from "@reducers/root.reducer";

export interface CalloutErrorProps {
  readyState: ReadyState;
  style?: CalloutButtonProps["style"];
}

export const CalloutError = ({ readyState, style }: CalloutErrorProps) => {
  const networkFailureScale = useSelector((state: IReduxState) => state.shared.networkFailureScale);

  React.useEffect(() => {
    const createTimeout = () =>
      setTimeout(() => {
        if (readyState.retry) {
          readyState.retry();
        }

        interval = createTimeout();
      }, calculateBackoffTimeout(networkFailureScale));

    let interval = createTimeout();

    return () => clearTimeout(interval);
  }, [networkFailureScale, readyState.retry]);

  return (
    <CalloutButton
      level="error"
      style={style}
      buttonProps={{ onClick: readyState.retry || undefined, children: "Retry" }}
    >
      Sorry, an error occurred while loading. We will try again in a few moments, or you can retry
      now.
    </CalloutButton>
  );
};
